import CardWithTitle from 'components/CardWithTitle';
import React from 'react';
import { HiArrowNarrowRight } from 'react-icons/hi';
import { Button, Col, Label, Row } from 'reactstrap';

const OrderInfoDetail = ({ deliveredOrders, totalOrders }) => {
  return (
    <CardWithTitle title="Orders">
      <Button
        color="link"
        className="text-decoration-none card-right-btn text-dark-525 font-manrope fw-bold f-12 p-0"
      >
        View all <HiArrowNarrowRight className="ms-1" size={18} />
      </Button>
      <Row className="mb-2">
        <Col sm={4}>
          <span className="font-manrope text-gray f-12 fw-semibold d-block text-uppercase">
            TOTAL ORDERS
          </span>
          <Label className="f-12 fw-medium">{deliveredOrders || 0}</Label>
        </Col>
        <Col sm={8}>
          <span className="font-manrope text-gray f-12 fw-semibold d-block text-uppercase">
            ORDER Delivered
          </span>
          <Label className="f-12 fw-medium">{totalOrders || 0}</Label>
        </Col>
      </Row>
    </CardWithTitle>
  );
};

export default OrderInfoDetail;
